// extracted by mini-css-extract-plugin
export default {"spinner":"spinner--T02EM","body":"body--iqKYi","stopped":"stopped--JwRM6","cyber-spin":"cyber-spin--Lc_QJ"};